import { render, staticRenderFns } from "./Profile.Address.vue?vue&type=template&id=a0580cd4&scoped=true"
import script from "./Profile.Address.vue?vue&type=script&lang=js"
export * from "./Profile.Address.vue?vue&type=script&lang=js"
import style0 from "./Profile.Address.vue?vue&type=style&index=0&id=a0580cd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0580cd4",
  null
  
)

export default component.exports